__turbopack_context__.v({
  "outer-link": "index-module-scss-module__PPxeda__outer-link",
});
